import React, { FC, useCallback } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { Slider, SliderProps } from 'Modules/ui3';


export const SliderField: FC<FieldRenderProps<number, HTMLElement, number> & SliderProps> = ({
    mutate, input: { onChange, value = 0, ...inputProps }, meta, ...props
}) => (
    <Slider
        {...props}
        {...inputProps}
        value={value}
        onChange={useCallback(
            (event, value) => {
                onChange(value);
                if (mutate)
                    mutate(value);
            },
            [mutate, onChange],
        )}
    />
);
